import { AnalyticsEvent } from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditSelectAllEvent implements AnalyticsEvent {
  name = "issue.edit.select.all";
  parameters = {};
}
